import React, { useEffect, useState, useContext, useMemo } from "react";
import "@styles/pages/GenericPage/TncPage.scss";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";

const TncPage = () => {
  const { t, i18n } = useTranslation();

  return (
    <Box className="tnc-container">
      <Box className="tnc-content-container">
        <Typography className="tnc-header">
          <Trans i18nKey="tnc:clubs_tnc_title" />
        </Typography>
        <Typography className="tnc-header">
          <Trans i18nKey="tnc:clubs_tnc_launched" />
        </Typography>
        <Box className="tnc-part-container">
          <Typography className="tnc-header">
            <Trans i18nKey="tnc:about_clubs" />
          </Typography>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:about_clubs_1"),
                }}
              />
            </li>
          </ul>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:about_clubs_2"),
                }}
              />
            </li>
          </ul>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:about_clubs_3"),
                }}
              />
            </li>
          </ul>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:about_clubs_4"),
                }}
              />
            </li>
          </ul>
        </Box>
        <Box className="tnc-part-container">
          <Typography className="tnc-header">
            <Trans i18nKey="tnc:eligibility_of_membership" />
          </Typography>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:eligibility_of_membership_1"),
                }}
              />
            </li>
          </ul>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:eligibility_of_membership_2"),
                }}
              />
            </li>
          </ul>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:eligibility_of_membership_3"),
                }}
              />
            </li>
          </ul>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:eligibility_of_membership_4"),
                }}
              />
            </li>
          </ul>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:eligibility_of_membership_5"),
                }}
              />
            </li>
          </ul>
          <ul>
            <li>
              <Typography
                className="tnc-point"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:eligibility_of_membership_6"),
                }}
              />
            </li>
          </ul>
        </Box>
        <Box className="tnc-part-container">
          <Typography className="tnc-header">
            <Trans i18nKey="tnc:how_to_earn_s_dollar" />
          </Typography>
          <Typography className="tnc-text">
            <Trans i18nKey="tnc:s_dollar_earning_mechanisms" />
          </Typography>
          <Box className="tnc-table">
            <table className="styled-table">
              <tr className="table-header">
                <th width="15%"></th>
                <th>
                  <Typography>
                    <Trans i18nKey="tnc:tnc_table_header_1" />
                  </Typography>
                </th>
                <th>
                  <Typography>
                    <Trans i18nKey="tnc:tnc_table_header_2" />
                  </Typography>
                </th>
              </tr>
              <tr className="table-row">
                <td>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: t("tnc:tnc_table_content_1_1"),
                    }}
                  />
                </td>
                <td>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: t("tnc:tnc_table_content_1_2"),
                    }}
                  />
                </td>{" "}
                <td>
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: t("tnc:tnc_table_content_1_3"),
                    }}
                  />
                </td>
              </tr>
              <tr className="table-row">
                <td colspan="1">
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: t("tnc:tnc_table_content_2_1"),
                    }}
                  />
                </td>
                <td colspan="2">
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: t("tnc:tnc_table_content_2_2"),
                    }}
                  />
                </td>
              </tr>
            </table>
          </Box>
        </Box>
        <Box className="tnc-part-container">
          <Typography className="tnc-text">
            <Trans i18nKey="tnc:s_dollar_are_redeemable_for_offers" />
          </Typography>
          <Typography className="tnc-header">
            <Trans i18nKey="tnc:note" />
          </Typography>
          <Typography className="tnc-text">
            <Trans i18nKey="tnc:note_content" />
          </Typography>
        </Box>
        <Box className="tnc-part-container">
          <Typography className="tnc-header">
            <Trans i18nKey="tnc:validity_period_of_s_dollars" />
          </Typography>
          <Typography className="tnc-text">
            {" "}
            <Typography
              dangerouslySetInnerHTML={{
                __html: t("tnc:validity_period_of_s_dollars_content"),
              }}
            />
          </Typography>
        </Box>
        <Box className="tnc-part-container">
          <Typography className="tnc-header">
            <Trans i18nKey="tnc:how_to_check_the_s_dollar_awarded" />
          </Typography>
          <Typography className="tnc-text">
            <Typography
              dangerouslySetInnerHTML={{
                __html: t("tnc:how_to_check_the_s_dollar_awarded_content"),
              }}
            />
          </Typography>
        </Box>
        <Box className="tnc-part-container">
          <Typography className="tnc-header">
            <Trans i18nKey="tnc:can_s_dollar_be_transferred" />
          </Typography>
          <Typography className="tnc-text">
            <Typography
              dangerouslySetInnerHTML={{
                __html: t("tnc:can_s_dollar_be_transferred_content"),
              }}
            />
          </Typography>
        </Box>
        <Box className="tnc-part-container">
          <Typography className="tnc-header">
            <Trans i18nKey="tnc:how_to_use_s_dollar" />
          </Typography>
          <ol>
            <li>
              <Typography
                dangerouslySetInnerHTML={{
                  __html: t("tnc:how_to_use_s_dollar_content_1"),
                }}
              />
            </li>
            <li>
              <Typography
                dangerouslySetInnerHTML={{
                  __html: t("tnc:how_to_use_s_dollar_content_2"),
                }}
              />
            </li>
          </ol>
          <Typography
            className="tnc-text"
            dangerouslySetInnerHTML={{
              __html: t("tnc:how_to_use_s_dollar_content"),
            }}
          />
        </Box>
        <Box className="tnc-part-container">
          <Typography
            className="tnc-header"
            dangerouslySetInnerHTML={{
              __html: t("tnc:earning_and_redemption_limit_of_s_dollars"),
            }}
          />{" "}
          <Typography
            className="tnc-header"
            dangerouslySetInnerHTML={{
              __html: t("tnc:s_dollars_earned_on_or_after_new"),
            }}
          />
          <ol>
            <li>
              {" "}
              <Typography
                className="tnc-text"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:earning_limit"),
                }}
              />
            </li>
            <li>
              <Typography
                className="tnc-text"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:redemption_limit"),
                }}
              />
            </li>{" "}
            <li>
              <Typography
                className="tnc-text"
                dangerouslySetInnerHTML={{
                  __html: t("tnc:birthday_bonus_s_dollars"),
                }}
              />
            </li>
          </ol>
        </Box>
        <Box className="tnc-part-container">
          <Typography
            className="tnc-text"
            dangerouslySetInnerHTML={{
              __html: t("tnc:s_dollars_earned_on_or_after_old"),
            }}
          />
        </Box>
        <Box className="tnc-part-container">
          <Typography
            className="tnc-text"
            dangerouslySetInnerHTML={{
              __html: t("tnc:offer_redemption_purchase_reminders"),
            }}
          />{" "}
        </Box>{" "}
        <Box className="tnc-part-container">
          <Typography
            className="tnc-text"
            dangerouslySetInnerHTML={{
              __html: t("tnc:gift_redemption_application_inquiries"),
            }}
          />{" "}
        </Box>{" "}
        <Box className="tnc-part-container">
          <Typography
            className="tnc-text"
            dangerouslySetInnerHTML={{
              __html: t("tnc:participation_in_events"),
            }}
          />{" "}
        </Box>{" "}
        <Box className="tnc-part-container">
          <Typography
            className="tnc-text"
            dangerouslySetInnerHTML={{
              __html: t("tnc:intellectual_property_and_disclaimers"),
            }}
          />{" "}
        </Box>{" "}
        <Box className="tnc-part-container">
          <Typography
            className="tnc-text"
            dangerouslySetInnerHTML={{
              __html: t("tnc:variations_of_terms_and_conditions"),
            }}
          />{" "}
        </Box>
      </Box>
    </Box>
  );
};
export default TncPage;
